var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.375C10.1458 21.375 8.33324 20.8252 6.79153 19.795C5.24982 18.7649 4.04821 17.3007 3.33863 15.5877C2.62906 13.8746 2.44341 11.9896 2.80514 10.171C3.16688 8.35246 4.05976 6.682 5.37088 5.37088C6.682 4.05976 8.35246 3.16688 10.171 2.80514C11.9896 2.44341 13.8746 2.62906 15.5877 3.33863C17.3007 4.04821 18.7649 5.24982 19.795 6.79153C20.8252 8.33324 21.375 10.1458 21.375 12C21.3722 14.4855 20.3836 16.8685 18.626 18.626C16.8685 20.3836 14.4855 21.3722 12 21.375ZM12 3.375C10.2941 3.375 8.62658 3.88085 7.20821 4.82858C5.78984 5.77631 4.68435 7.12335 4.03154 8.69936C3.37874 10.2754 3.20793 12.0096 3.54073 13.6827C3.87353 15.3557 4.69498 16.8926 5.90121 18.0988C7.10744 19.305 8.64426 20.1265 10.3174 20.4593C11.9904 20.7921 13.7246 20.6213 15.3006 19.9685C16.8767 19.3157 18.2237 18.2102 19.1714 16.7918C20.1192 15.3734 20.625 13.7059 20.625 12C20.6224 9.7133 19.7129 7.521 18.096 5.90406C16.479 4.28712 14.2867 3.37758 12 3.375Z",
    fill: "var(--color, #333333)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.bc33fa70d63147cc5604719d723be9f4.svg";
export { ForwardRef as ReactComponent };